import React, { useRef } from "react";
import { Box, Card } from '@curves/ui-base';

import useEChart from "@Util/hook/useEChart";
import ChartSkeletonLoading from "@Local/Dashboard/Components/ChartSkeletonLoading";
import { adaptBar } from "@Local/Dashboard/dashboard.util";
/********* 新會員來源 *********/
const NewMemberSource = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const {
		sourceData = {
			xAxis: ["網路廣告", "既有名單", "自店社群", "口碑介紹", "其他"],
			data: [12, 8, 5, 3, 2],
		},
	} = props;
	const { data = [], axisLabels = [] } = adaptBar(sourceData);
	const isLoading = data.length === 0;
	const title = "新會員來源";
	const option = {
		title: {
			left: 24,
			top: 20,
			text: title,
			textStyle: {
				fontSize: 20,
				fontWeight: 600,
				color: "#1F2937",
			},
		},
		grid: {
			left: 150,
			right: 40,
			top: 70,
			bottom: 30,
		},
		tooltip: {
			trigger: "axis",
			axisPointer: {
				type: "shadow",
			},
		},
		xAxis: [
			{
				type: "value",
				axisLabel: { show: false }, // 數值文字（0, 100, 200）
				axisTick: { show: false }, // 刻度線
				axisLine: { show: false }, // 軸線
				splitLine: { show: false }, // 背景格線（直線）
			},
		],
		yAxis: [
			{
				type: "category",
				inverse: true, // 反轉
				data: axisLabels,
				axisLabel: {
					fontSize: 14,
					color: "#374151",
					margin: 8,
				},
				axisTick: { show: false },
				axisLine: { show: true },
				splitLine: { show: false },
			},
		],
		series: [
			{
				name: "Value",
				type: "bar",
				barWidth: "60%",
				data: data,
				itemStyle: {
					borderRadius: [0, 6, 6, 0],
					color: "rgb(148, 163, 184)",
				},
			},
		],
	};
	useEChart(chartDomRef, option);
	return (
		<Card style={{ width: "100%", height: "100%" }}>
			<Card.CardContent style={{ width: "100%", height: "100%" }}>
				{isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
			</Card.CardContent>
		</Card>
	);
});
export default NewMemberSource;
